import { Injectable } from '@angular/core';
import { HttpCacheStore } from './http-cache.store';
import { AuthService } from '../services/auth.service';
import { BaseHttpCacheInterceptor } from './base-http-cache.interceptor';

export { CACHE_RESET_HEADER, CACHE_SKIP_HEADER } from './base-http-cache.interceptor';

@Injectable()
export class HttpCacheInterceptor extends BaseHttpCacheInterceptor {

  constructor(cacheStore: HttpCacheStore, authService: AuthService) {
    super(cacheStore, authService);
  }

  /** SSR se inject hua group data bhi purana ho jata hai, is liye saath hi clear karein. */
  protected override onCacheReset(): void {
    window["GROUP_INFO"] = null;
    window['GROUP_ADDONS'] = null;
    window["GROUP_INFO_FULL"] = null;
  }
}
